import API, { defaultHeaders } from '../';

const login = async (payload = {}) => {
  const {
    headers = {},
    body = {},
  } = payload;

  Object.assign(headers, defaultHeaders);

  return fetch(`${API}/auth/login/`, {
    method: 'post',
    headers,
    body: JSON.stringify(body),
  });
};

export default login;
